import React, { Component } from 'react';
import { withProps } from 'recompose';
import { pick } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';
import style from './index.scss';

export class StretchText extends Component {
    constructor(props) {
        super(props);

        this.state = {
            size: 1
        };

        this.textEl = React.createRef();
    }

    componentDidMount() {
        this.scaleText();

        window.addEventListener('orientationchange', this.rotationListener);
    }

    rotationListener = () => {
        const time = this.props.os === 'android' ? 100 : 0;

        // Waiting until browser updates page view
        setTimeout(() => this.setState({ size: 1 }, this.scaleText), time);
    };

    componentWillUnmount() {
        window.removeEventListener('orientationchange', this.rotationListener);
    }

    scaleText() {
        const { scrollWidth = 1, clientWidth = 1 } = this.textEl.current || {};
        const { indent = 0 } = this.props;
        const scale = clientWidth / scrollWidth;

        scale < 1 && this.setState({ size: scale - indent });
    }

    render() {
        const { className = '', children } = this.props;
        const { size } = this.state;

        return <div className={className} ref={this.textEl}>
            <span className={style.text}
                style={{ fontSize: `${size}em` }}>{children}</span>
        </div>;
    }
}

export default withProps(
    () => useDeviceSelector(pick(['os']))
)(StretchText);
